// Swiper Import from npm package

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Grid } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import 'swiper/css/grid';

// Swiper Custom JS

new Swiper('.news-slider .swiper', {
    modules: [Keyboard, Pagination],
    loop: false,
    slideToClickedSlide: true,
    keyboard: {
        enabled: true,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    slidesPerView: 4,
    spaceBetween: 20,
    on: {
        init: function () {
            updateGradient(this);
        },
        slideChange: function () {
            updateGradient(this);
        },
        resize: function () {
            updateGradient(this);
        },
    },
    breakpoints: {
        100: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 50,
        },
    },
});

function updateGradient(swiper) {
    const wrapper = swiper.el.closest('.news-slider');
    const slides = swiper.slides;
    const activeIndex = swiper.activeIndex;

    // Clear previous states
    wrapper.classList.remove('show-prev', 'show-next');

    // Check if there's a previous slide visible
    if (activeIndex > 0 || swiper.params.loop) {
        wrapper.classList.add('show-prev');
    }

    // Check if there's a next slide visible
    if (activeIndex < slides.length - swiper.params.slidesPerView || swiper.params.loop) {
        wrapper.classList.add('show-next');
    }
}
